import { apiService } from './api'

const BASE = '/application-parameters'

const unwrap = (res) => res.data

const applicationParametersService = {
  get: () => apiService.get(BASE).then(unwrap),
  save: (payload) => apiService.put(BASE, payload).then(unwrap),
  getFx: () => apiService.get(`${BASE}/fx`).then(unwrap),
}

export default applicationParametersService
